<template>
  <v-container class="page-content px-5" style="  width: 100%">
    <v-toolbar
        class="removeBtnPaddingRight rounded-t-lg"
        color="#DADADA"
        flat
        dense
    >
    </v-toolbar>
    <v-data-table
        :headers="headers"
        :items="items"
        @click:row="openDetail"
        :loading="isLoading"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.size"
        :server-items-length="count"
        :footer-props="{'items-per-page-options':[25,50,100]}"
        class="elevation-1 row-pointer rounded-b-lg"
    >
      <template v-slot:item.created="{item}">
        <span>{{displayDate(item.created,true)}}</span>
      </template>
      <template v-slot:item.has_error="{item}">
        <v-icon v-if="item.has_error">done</v-icon>
        <v-icon v-else>close</v-icon>
      </template>
      <template v-slot:item.unloading="{item}">
        <v-icon v-if="item.unloading">done</v-icon>
        <v-icon v-else>close</v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="loadData()"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
  </v-container>

</template>


<script>
import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import names from "@/modules/admin/routers/names";
import admin from "@/urls/roles/admin";
import names_core from "@/modules/core/routers/names";
import {displayDate} from "@/helper";

export default {
  name: "AdminCarsList",
  components: { },
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список формирующихся файлов",
      show: false,
      selectors: {
        model: []
      },
      headers: [
        {text: "ФИО", value: "user", sortable: false, align: "start", width: "20%"},
        {text: "Поставленно в очередь", value: "created", align: "start", sortable: false, width: "10%"},
        {text: "Ошибка при формировании", value:"has_error", align: "start", sortable: false, width: "10%"},
        {text: "Сформировано", value: "unloading" , align: "start", sortable: false, width: "10%"}
      ]
    }
  },
  computed: {
    ...mapGetters({
      items: "admin/getFile",
      count: "admin/getFileCount",
      isLoading: "admin/isLoadingFile"
    })
  },
  watch: {
  },
  methods: {
    displayDate:displayDate,
    ...mapActions({
      loadFileList: "admin/loadFileList"
    }),
    openDetail(item){
      this.$router.push({name: names.FILE.DETAIL, params: {idFile: item.id}}).catch(() => {})
    },
    loadData(url = undefined) {
      this.loadFileList({
        url: url,
        urlAppend: (url) => {
          return this.addPageParameter(this.addSizeParameter(url));
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    }
  },
  created() {
    if (admin.ADMIN.ALLOWED()){
      this.loadData()
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
